/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CancelDataSharingRequestsDto,
  CancelOperationResponseDto,
  ErrorResponse,
  RequestPatientDataSharingDto,
  RequestPatientDataSharingResponseDto,
} from '../models/index';
import {
    CancelDataSharingRequestsDtoFromJSON,
    CancelDataSharingRequestsDtoToJSON,
    CancelOperationResponseDtoFromJSON,
    CancelOperationResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    RequestPatientDataSharingDtoFromJSON,
    RequestPatientDataSharingDtoToJSON,
    RequestPatientDataSharingResponseDtoFromJSON,
    RequestPatientDataSharingResponseDtoToJSON,
} from '../models/index';

export interface CancelDataSharingRequestsRequest {
    cancelDataSharingRequestsDto: CancelDataSharingRequestsDto;
}

export interface RequestPatientDataSharingRequest {
    requestPatientDataSharingDto: RequestPatientDataSharingDto;
}

/**
 * 
 */
export class PracticePatientManagementApi extends runtime.BaseAPI {

    /**
     * Practice user cancels pending data sharing requests. Only requests in \'requesting\' status can be canceled. Returns list of successful and failed operations.
     * Cancel pending data sharing requests
     */
    async cancelDataSharingRequestsRaw(requestParameters: CancelDataSharingRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CancelOperationResponseDto>> {
        if (requestParameters['cancelDataSharingRequestsDto'] == null) {
            throw new runtime.RequiredError(
                'cancelDataSharingRequestsDto',
                'Required parameter "cancelDataSharingRequestsDto" was null or undefined when calling cancelDataSharingRequests().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-patients/cancel-requests`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CancelDataSharingRequestsDtoToJSON(requestParameters['cancelDataSharingRequestsDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CancelOperationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Practice user cancels pending data sharing requests. Only requests in \'requesting\' status can be canceled. Returns list of successful and failed operations.
     * Cancel pending data sharing requests
     */
    async cancelDataSharingRequests(requestParameters: CancelDataSharingRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CancelOperationResponseDto> {
        const response = await this.cancelDataSharingRequestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Practice user requests data sharing access to a patient\'s profile data by providing the patient\'s email address
     * Request data sharing access to patient profile data
     */
    async requestPatientDataSharingRaw(requestParameters: RequestPatientDataSharingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RequestPatientDataSharingResponseDto>> {
        if (requestParameters['requestPatientDataSharingDto'] == null) {
            throw new runtime.RequiredError(
                'requestPatientDataSharingDto',
                'Required parameter "requestPatientDataSharingDto" was null or undefined when calling requestPatientDataSharing().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-patients/request-data-sharing`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestPatientDataSharingDtoToJSON(requestParameters['requestPatientDataSharingDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RequestPatientDataSharingResponseDtoFromJSON(jsonValue));
    }

    /**
     * Practice user requests data sharing access to a patient\'s profile data by providing the patient\'s email address
     * Request data sharing access to patient profile data
     */
    async requestPatientDataSharing(requestParameters: RequestPatientDataSharingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RequestPatientDataSharingResponseDto> {
        const response = await this.requestPatientDataSharingRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
